import React, { createContext, useEffect, useState } from "react";
import api from "../services/api";

export const DashboardsContext = createContext({});
function DashboardsProvider({ children }) {
  const [countsPerformed, setCountsPerformed] = useState();
  const [progressCounts, setProgressCounts] = useState();

  const [countsMath, setCountsMath] = useState();
  const [countsNotMath, setCountsNotMath] = useState();
  const [countsLeftOver, setCountsLeftOver] = useState();

  const [countPrimary, setCountPrimary] = useState();
  const [countSecondary, setCountSecondary] = useState();
  const [countThree, setCountThree] = useState();

  const [countFour, setCountFour] = useState();

  const [theft, setTheft] = useState();
  const [registrationError, setRegistrationError] = useState();
  const [operationError, setOperationError] = useState();

  const getResumeProgress = async (client, type, location) => {
    if (location != undefined) {
      const response = await api.post(
        "dashboard/resume/progress/location/location",
        {
          client: client,
          type: type,
          location: location,
        }
      );

      console.log(response.data, 777, location);

      if (response.status == 200) {
        setCountsPerformed(response.data.countsPerformed);
        setProgressCounts(response.data.progressCounts);
      }
    } else if (type) {
      const response = await api.post("/dashboard/resume/progress/type", {
        client: client,
        type: type,
      });

      if (response.status == 200) {
        setCountsPerformed(response.data.countsPerformed);
        setProgressCounts(response.data.progressCounts);
      }
    } else {
      const response = await api.post("dashboard/resume/progress", {
        client: client,
      });

      if (response.status == 200) {
        setCountsPerformed(response.data.countsPerformed);
        setProgressCounts(response.data.progressCounts);
      }
    }
  };

  const getResumeProgressAccuracy = async (client, type, location) => {
    if (location != undefined) {
      const response = await api.post("dashboard/accuracy/progress/location", {
        client: client,
        type: type,
        location: location,
      });

      if (response.status == 200) {
        setCountsMath(Number(response.data.countsMath).toFixed(2));
        setCountsNotMath(Number(response.data.countsMissing).toFixed(2));
        setCountsLeftOver(Number(response.data.countsOver).toFixed(2));
      }
    } else if (type) {
      const response = await api.post("dashboard/accuracy/progress/type", {
        client: client,
        type: type,
      });

      if (response.status == 200) {
        setCountsMath(Number(response.data.countsMath).toFixed(2));
        setCountsNotMath(Number(response.data.countsMissing).toFixed(2));
        setCountsLeftOver(Number(response.data.countsOver).toFixed(2));
      }
    } else {
      const response = await api.post("dashboard/accuracy/progress", {
        client: client,
      });

      if (response.status == 200) {
        setCountsMath(Number(response.data.countsMath).toFixed(2));
        setCountsNotMath(Number(response.data.countsMissing).toFixed(2));
        setCountsLeftOver(Number(response.data.countsOver).toFixed(2));
      }
    }
  };

  const getResumeProgressDetails = async (client, type, location) => {
    if (location != undefined) {
      const response = await api.post("dashboard/details/progress/location", {
        client: client,
        type: type,
        location: location,
      });

      if (response.status == 200) {
        setCountPrimary(response.data.totalFirstCountage);
        setCountSecondary(response.data.totalSecondaryCountage);
        setCountThree(response.data.totalThreeCountage);
        setCountFour(response.data.totalFourCountage);
      }
    } else if (type) {
      const response = await api.post("dashboard/details/progress/type", {
        client: client,
        type: type,
      });

      if (response.status == 200) {
        setCountPrimary(response.data.totalFirstCountage);
        setCountSecondary(response.data.totalSecondaryCountage);
        setCountThree(response.data.totalThreeCountage);
        setCountFour(response.data.totalFourCountage);
      }
    } else {
      const response = await api.post("dashboard/details/progress", {
        client: client,
      });

      if (response.status == 200) {
        setCountPrimary(response.data.totalFirstCountage);
        setCountSecondary(response.data.totalSecondaryCountage);
        setCountThree(response.data.totalThreeCountage);
        setCountFour(response.data.totalFourCountage);
      }
    }
  };

  const getDivergencesDetails = async (client, type, location) => {
    if (location != undefined) {
      const response = await api.post(
        "dashboard/divergences/progress/location",
        {
          client: client,
          reasonErrors: type,
          type: type,
          location: location,
        }
      );

      if (response.status == 200) {
        setTheft(response.data.theftNumber);
        setRegistrationError(response.data.setRegistrationError);
        setOperationError(response.data.operationError);
      }
    } else if (type) {
      const response = await api.post("dashboard/divergences/progress", {
        client: client,
        reasonErrors: type,
        type: type,
      });

      if (response.status == 200) {
        setTheft(response.data.theftNumber);
        setRegistrationError(response.data.setRegistrationError);
        setOperationError(response.data.operationError);
      }
    } else {
      const response = await api.post("dashboard/divergences/progress", {
        client: client,
        reasonErrors: type,
      });

      if (response.status == 200) {
        setTheft(response.data.theftNumber);
        setRegistrationError(response.data.setRegistrationError);
        setOperationError(response.data.operationError);
      }
    }
  };

  useEffect(() => {
    console.log(countsLeftOver, countsNotMath, countsMath);
  }, [countsLeftOver]);

  return (
    <DashboardsContext.Provider
      value={{
        getResumeProgress,
        countsPerformed,
        progressCounts,
        getResumeProgressAccuracy,
        countsMath,
        countsNotMath,
        countsLeftOver,
        getResumeProgressDetails,
        countPrimary,
        countSecondary,
        countThree,
        countFour,
        getDivergencesDetails,
        theft,
        registrationError,
        operationError,
      }}
    >
      {children}
    </DashboardsContext.Provider>
  );
}

export default DashboardsProvider;
